// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"224":"81bcd5c0","692":"df5c541d","884":"5b79c5f5"}[chunkId] + ".chunk.css";
};